import React from 'react'

import AvailabilityStatusFilter from './AvailabilityStatusFilter'
import AvailabilityStatusOriginFilter from './AvailabilityStatusOriginFilter'
import FullPlacesFilterV2 from '../../../../containers/places/filters/FullPlacesFilterV2'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="place_availability" open={open}>
      <AvailabilityStatusFilter />
      <AvailabilityStatusOriginFilter />
      {/* `places` (unlike most other entities) filters a specific place by `ids`, not `placeIds`. */}
      <FullPlacesFilterV2 field="ids" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
